export default "__VITE_PUBLIC_ASSET__50aad20b__"